// ** Auth Endpoints
const API_URL = process.env.REACT_APP_BACKEND_URL;

export default {
  loginEndpoint: API_URL + "account/login",
  registerEndpoint: API_URL + "account/register",
  refreshEndpoint: "/jwt/refresh-token",
  logoutEndpoint: "/jwt/logout",

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};
